// Visually accurate replica of the reCAPTCHA checkbox widget (no real functionality)
export default function RecaptchaWidget({ phase, onCheckboxClick, onAnnotate }) {
  const isLoading = phase === 'loading' || phase === 'verify'
  const isIdle = phase === 'idle'

  return (
    <div
      onMouseEnter={() => isIdle && onAnnotate(null)}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 300,
        height: 74,
        background: '#f9f9f9',
        border: '1px solid #d3d3d3',
        borderRadius: 3,
        boxShadow: '0 0 4px 1px rgba(0,0,0,0.08)',
        fontFamily: 'Roboto, Arial, sans-serif',
        userSelect: 'none',
      }}
    >
      {/* Left: checkbox + label */}
      <div style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>
        <div style={{ width: 28, height: 28, position: 'relative', flexShrink: 0 }}>

          {/* Idle checkbox */}
          {isIdle && (
            <button
              type="button"
              onClick={onCheckboxClick}
              onMouseEnter={() => onAnnotate('checkbox')}
              onMouseLeave={() => onAnnotate(null)}
              style={{
                position: 'absolute',
                inset: 0,
                background: '#fff',
                border: '2px solid #c1c1c1',
                borderRadius: 2,
                cursor: 'pointer',
                outline: 'none',
                padding: 0,
                transition: 'border-color 0.15s, box-shadow 0.15s',
              }}
              onMouseOver={e => {
                e.currentTarget.style.borderColor = '#b2b2b2'
                e.currentTarget.style.boxShadow = '0 0 3px rgba(0,0,0,0.15)'
              }}
              onMouseOut={e => {
                e.currentTarget.style.borderColor = '#c1c1c1'
                e.currentTarget.style.boxShadow = 'none'
              }}
            />
          )}

          {/* Spinner — keeps spinning indefinitely */}
          {isLoading && (
            <div
              className="animate-spin"
              style={{
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                border: '3px solid #e0e0e0',
                borderTopColor: '#666',
              }}
            />
          )}
        </div>

        <span style={{
          marginLeft: 14,
          fontSize: 14,
          color: '#202124',
          letterSpacing: '0.01em',
          fontWeight: 400,
        }}>
          I'm not a robot
        </span>
      </div>

      {/* Right: reCAPTCHA branding */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        marginRight: 10,
        paddingLeft: 10,
        borderLeft: '1px solid #d3d3d3',
        height: 48,
      }}>
        <img
          src="https://wpforms.com/wp-content/uploads/2024/08/google-recaptcha-logo.png"
          alt="reCAPTCHA"
          style={{ width: 30, height: 30, objectFit: 'contain' }}
        />
        <span style={{ fontSize: 8, color: '#555', lineHeight: 1 }}>reCAPTCHA</span>
        <div style={{ fontSize: 7, color: '#555', lineHeight: 1 }}>
          <a
            style={{ color: '#555', textDecoration: 'none' }}
            onClick={e => e.preventDefault()}
            onMouseOver={e => e.currentTarget.style.textDecoration = 'underline'}
            onMouseOut={e => e.currentTarget.style.textDecoration = 'none'}
          >
            Privacy
          </a>
          {' - '}
          <a
            style={{ color: '#555', textDecoration: 'none' }}
            onClick={e => e.preventDefault()}
            onMouseOver={e => e.currentTarget.style.textDecoration = 'underline'}
            onMouseOut={e => e.currentTarget.style.textDecoration = 'none'}
          >
            Terms
          </a>
        </div>
      </div>
    </div>
  )
}
